import React from "react";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import "./HomeCta.css";

const HomeCta = () => (
  <section className="home-cta" aria-labelledby="home-cta-title">
    <div className="home-cta__glow" />
    <div className="home-cta__content">
      <p className="home-cta__eyebrow">Have a challenging requirement?</p>
      <h2 id="home-cta-title">Let&apos;s engineer the right solution together.</h2>
      <p className="home-cta__text">
        Share your requirements with our team and discover how Hardcoats can
        support your next precision engineering project.
      </p>
      <div className="home-cta__actions">
        <Link to="/contact" className="home-cta__primary">
          Talk to our team <ArrowRightIcon />
        </Link>
        <Link to="/products" className="home-cta__secondary">Explore products</Link>
      </div>
    </div>
    <span className="home-cta__mark">H</span>
  </section>
);

export default HomeCta;
